import api from './api';

export interface UploadedAttachment {
  id: string;
  filename: string;
  mime: string;
  size_bytes: number;
  kind: 'image' | 'pdf' | 'docx' | 'txt' | 'other';
  ai_status: 'pending' | 'done' | 'failed' | 'skipped';
  ai_summary?: string | null;
  detected_items?: any[];
  error?: string | null;
  created_at?: string;
}

export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
export const MAX_FILES_PER_MESSAGE = 5;
export const ACCEPT_ATTR = 'image/jpeg,image/png,image/webp,image/gif,image/heic,image/heif,.heic,.heif,application/pdf,.pdf,.docx,.txt,.md';

export async function uploadAttachment(file: File): Promise<UploadedAttachment> {
  const fd = new FormData();
  fd.append('file', file);
  const { data } = await api.post('/uploads', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000,
  });
  return data.attachment as UploadedAttachment;
}

export function attachmentFileUrl(id: string, token?: string | null): string {
  // Note: /uploads/:id/file requires Authorization. For inline display in
  // <img> tags we can't easily attach headers, so callers should fetch a blob
  // via api.get(...,{ responseType: 'blob' }) and createObjectURL when needed.
  return `/api/uploads/${id}/file${token ? `?t=${encodeURIComponent(token)}` : ''}`;
}

export async function fetchAttachmentBlobUrl(id: string): Promise<string> {
  const res = await api.get(`/uploads/${id}/file`, { responseType: 'blob' });
  return URL.createObjectURL(res.data);
}
